import React from 'react';
import { MapPin } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

/** Held invoice whose customer name has several branches: pick the right one → the invoice is re-checked and pushed. */
export const HoldBranchPick = ({ choices, value, disabled, onPick, testId }) => (
  <Select value={value || ''} onValueChange={onPick} disabled={disabled}>
    <SelectTrigger className="mt-1 h-8 w-64 border-amber-300 bg-amber-50 text-xs" data-testid={testId}>
      <SelectValue placeholder={`Pick the branch (${choices.length})`} />
    </SelectTrigger>
    <SelectContent className="max-w-[420px]">
      {choices.map((c) => (
        <SelectItem key={c.id} value={c.id} className="py-2" data-testid={`${testId}-opt-${c.id}`}>
          <div className="flex items-center gap-1.5 text-sm font-medium">
            <MapPin className="w-3.5 h-3.5 shrink-0 text-[#2D5F4F]" />{c.place || '—'} · {c.pincode || 'no PIN'} · <span className="font-mono">{c.id}</span>
          </div>
          {c.address && <div className="pl-5 text-xs text-gray-500 whitespace-normal">{c.address}</div>}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default HoldBranchPick;
